import { AssigneeInput } from 'components/widgets/RiskRegister/components/UploadRisksButton/components/UploadRisksModal/components/FormContent/components/AssigneeInput/AssigneeInput';
import { FileUploadInput } from 'components/widgets/RiskRegister/components/UploadRisksButton/components/UploadRisksModal/components/FormContent/components/FileUploadInput/FileUploadInput';
import { TagsInput } from 'components/widgets/RiskRegister/components/UploadRisksButton/components/UploadRisksModal/components/FormContent/components/TagsInput/TagsInput';

export const FormContent = () => {
    return (
        <>
            <FileUploadInput />
            <AssigneeInput />
            <TagsInput />
        </>
    );
};
